export default "__VITE_ASSET__40c15633__"